import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#D1B608",
        d: "M11 10.9029c0-.7309.5925-1.3234 1.3233-1.3234h22.8751c.7308 0 1.3233.5925 1.3233 1.3234v28.3574c0 .7309-.5925 1.3234-1.3233 1.3234H12.3233c-.7308 0-1.3233-.5925-1.3233-1.3234z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFDD0A",
        d: "M11.8483 10.9439c0-.7309.5925-1.3234 1.3233-1.3234h22.8751c.7308 0 1.3233.5925 1.3233 1.3234v28.3574c0 .7309-.5925 1.3234-1.3233 1.3234H13.1716c-.7308 0-1.3233-.5925-1.3233-1.3234z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#807053",
        d: "M14.7339 8.209a.709.709 0 1 1 1.4179 0v2.7412a.709.709 0 0 1-1.4179 0zm4.6317 0a.709.709 0 0 1 1.4179 0v2.7412a.709.709 0 0 1-1.4179 0zm4.6317 0a.709.709 0 0 1 1.4179 0v2.7412a.709.709 0 0 1-1.4179 0zm4.6317 0a.709.709 0 0 1 1.4179 0v2.7412a.709.709 0 0 1-1.4179 0zm4.6318 0a.709.709 0 1 1 1.4178 0v2.7412a.709.709 0 0 1-1.4178 0z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#D1B608",
        d: "M14.8167 22.0761h4.4427v3.8755h-4.4427zm5.9381 1.2724h13.6116v.9453H20.7548zm-5.9381 11.0157h4.4427v3.8755h-4.4427zm6.1452 1.4178h13.6116v.9453H20.9619zm-6.1452-7.6562h4.4427v3.8755h-4.4427zm6.1452 1.4178h13.6116v.9453H20.9619z"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#80742B",
        d: "M31.2089 19.5978v-5.2899h2.1852q.5941 0 1.0254.2325.434.2298.669.6431.235.4107.2351.9557 0 .5476-.2402.9583-.2377.4081-.6794.6328t-1.0486.2247h-.8679v-1.0073h.6302q.2894 0 .483-.1007.1963-.1008.2971-.2816.1007-.1834.1007-.4262 0-.2454-.1007-.4236-.1008-.1808-.2971-.2789-.1962-.0982-.483-.0982h-.6302v4.2593z"
    }, "4")
], "AppPlanner", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
